import React from 'react'

const UserContext = React.createContext(0, () => 1);
export default UserContext;